var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-max-sm"},[_c('validation-observer',{attrs:{"slim":""}},[_c('account-details-card')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }